import { AfterViewInit, Component, OnInit } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { debounceTime } from 'rxjs';
import { IProduto } from 'src/app/services/ProdutoService/produto.model';
import { ProdutoService } from 'src/app/services/ProdutoService/produto.service';
import { SwalAlertService } from 'src/app/services/SwalAlertService/swalAlert.service';
import {
  labelStatusProduto,
  labelUnidadeMedida,
  STATUS_PRODUTO_OPTIONS
} from '../../estoque.constants';

@Component({
  selector: 'app-listagem-produto',
  templateUrl: './listagem-produto.component.html',
  styleUrls: ['./listagem-produto.component.scss']
})
export class ListagemProdutoComponent implements OnInit, AfterViewInit {
  form = this.fb.group({
    NM_PROD: [''],
    NU_STTS: [''],
    PAGE_NUMBER: [1, Validators.required],
    PAGE_SIZE: [8, Validators.required]
  });

  isLoading = false;
  tableData: Array<any> = [];
  maxPages = 1;
  expandirCardsMobile = true;
  statusOptions = [{ name: 'Todos', value: '' }, ...STATUS_PRODUTO_OPTIONS];

  tableColumns = [
    { header: 'Código', key: 'codigo', type: 'text' },
    { header: 'Nome', key: 'nome', type: 'text' },
    { header: 'Descrição', key: 'descricao', type: 'text' },
    { header: 'Valor Unit.', key: 'valorUnit', type: 'text' },
    { header: 'Unidade', key: 'unidade', type: 'text' },
    { header: 'Saldo', key: 'saldo', type: 'text' },
    { header: 'Status', key: 'status', type: 'text' },
    {
      header: 'Ações',
      key: 'actions',
      type: 'buttons',
      buttons: [
        {
          label: 'Visualizar',
          img: 'assets/eye-icon.png',
          action: (item: any) => this.visualizarProduto(item)
        },
        {
          label: 'Editar',
          img: 'assets/edit.svg',
          action: (item: any) => this.editarProduto(item)
        },
        {
          label: 'Excluir',
          img: 'assets/trashcan.png',
          action: (item: any) => this.excluirProduto(item)
        }
      ]
    }
  ];

  constructor(
    private fb: FormBuilder,
    private router: Router,
    private produtoService: ProdutoService,
    public swalAlert: SwalAlertService
  ) {}

  ngOnInit(): void {
    this.loadData();
  }

  ngAfterViewInit(): void {
    this.form.valueChanges.pipe(debounceTime(300)).subscribe(() => this.loadData());
  }

  navegarCadastro(): void {
    this.router.navigate(['cadastro/estoque/produto']);
  }

  mudarPagina(page: number): void {
    this.form.controls.PAGE_NUMBER.setValue(page + 1);
    this.loadData();
  }

  onChangeStatus(event: string | null): void {
    this.form.controls.NU_STTS.setValue(event);
  }

  loadData(): void {
    this.isLoading = true;
    const statusRaw = this.form.controls.NU_STTS.value;
    const params: any = {
      NM_PROD: this.form.controls.NM_PROD.value || undefined,
      PAGE_NUMBER: this.form.controls.PAGE_NUMBER.value,
      PAGE_SIZE: this.form.controls.PAGE_SIZE.value
    };
    if (statusRaw !== '' && statusRaw !== null && statusRaw !== undefined) {
      params.NU_STTS = Number(statusRaw);
    }

    this.produtoService.GetProdutosPaginated(params).subscribe({
      next: response => {
        this.tableData = (response.ITEMS ?? []).map((item: IProduto) => ({
          codigo: item.PK_PROD,
          nome: item.NM_PROD,
          descricao: item.TX_DESC ?? '---',
          valorUnit: Number(item.VL_UNIT).toLocaleString('pt-BR', {
            style: 'currency',
            currency: 'BRL'
          }),
          unidade: labelUnidadeMedida(item.NU_UNID_MED),
          saldo: item.QT_SALD ?? 0,
          status: labelStatusProduto(item.NU_STTS),
          ...item
        }));
        this.maxPages = response.TOTAL_PAGES ?? 1;
        this.isLoading = false;
      },
      error: () => {
        this.isLoading = false;
      }
    });
  }

  editarProduto(item: any): void {
    this.router.navigate(['cadastro/estoque/produto'], {
      queryParams: { codigo: item.PK_PROD, modoProduto: 'Editar' }
    });
  }

  visualizarProduto(item: any): void {
    this.router.navigate(['cadastro/estoque/produto'], {
      queryParams: { codigo: item.PK_PROD, modoProduto: 'Visualizar' }
    });
  }

  excluirProduto(item: any): void {
    this.swalAlert.showAlert(
      'Atenção!',
      'Deseja excluir este produto?',
      'warning',
      true,
      true,
      undefined,
      () => {
        this.isLoading = true;
        this.produtoService.DeleteProduto(item.PK_PROD).subscribe({
          next: () => {
            const isLastItemOnPage = this.tableData.length === 1;
            const currentPage = Number(this.form.controls.PAGE_NUMBER.value);

            if (isLastItemOnPage && currentPage > 1) {
              this.form.controls.PAGE_NUMBER.setValue(currentPage - 1, {
                emitEvent: false
              });
            }

            this.swalAlert.showAlert('Sucesso!', 'Produto excluído.', 'success');
            this.loadData();
          },
          error: () => {
            this.isLoading = false;
          }
        });
      }
    );
  }
}
